import { Link } from 'react-router-dom';

import { ROUTE_PROCESSES } from '@/utils/constants';

import LogoSVG from './logo.svg';

export const Logo = () => (
  <Link
    className="flex h-9 items-center justify-center border-0 bg-transparent pt-2 pr-4 pb-3 pl-3"
    to={ROUTE_PROCESSES}
  >
    <LogoSVG />
  </Link>
);
